import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="tab"
export default class extends Controller {
  static targets = ["tab", "panel", "heading"];

  connect() {
    this.updateActiveTab(0);
  }

  // タブがクリックされた時の処理
  changeTabs(event) {
    const newTab = event.currentTarget;
    const targetPanelId = newTab.dataset.panelId;
    const targetPanel = document.getElementById(targetPanelId);

    this.updateTabSelection(newTab);
    this.updatePanelVisibility(targetPanel);
    this.updateHeadingText(newTab.innerText);
  }

  // キーダウンイベントが発生したときの処理
  handleKeydown(event) {
    const keyActions = {
      ArrowLeft: () => this.moveFocus(-1),
      ArrowRight: () => this.moveFocus(1),
    };

    const action = keyActions[event.key];
    if (action) action();
  }

  // タブフォーカスの更新
  updateTabFocus(newIndex) {
    this.updateActiveTab(newIndex);
    this.tabTargets[this.tabFocus].focus();
  }

  // アクティブなタブを更新 (フォーカスは移動しない)
  updateActiveTab(newIndex) {
    const numTabs = this.tabTargets.length;
    this.tabFocus = (newIndex + numTabs) % numTabs;
    this.tabTargets[this.tabFocus].setAttribute("tabindex", 0);
  }

  // フォーカスの移動処理
  moveFocus(direction) {
    this.tabTargets[this.tabFocus].setAttribute("tabindex", -1);
    this.updateTabFocus(this.tabFocus + direction);
  }

  // タブの選択状態を更新
  updateTabSelection(newTab) {
    this.tabTargets.forEach((tab) => {
      tab.setAttribute("aria-selected", "false");
    });
    newTab.setAttribute("aria-selected", "true");
  }

  // パネルの表示状態を更新
  updatePanelVisibility(targetPanel) {
    this.panelTargets.forEach((panel) => {
      panel.setAttribute("aria-hidden", "true");
    });
    targetPanel.setAttribute("aria-hidden", "false");
  }

  // 見出しテキストの更新
  updateHeadingText(text) {
    if (this.hasHeadingTarget) {
      this.headingTarget.innerText = text;
    }
  }
}
